export default "__VITE_ASSET__JHoQ6p8i6fc3EqEge06Fow__"